import * as mediasoup from "mediasoup-client";

export default class DonatorPrivate {
  constructor(data, roomID) {
    this.g = data;
    this.roomID = roomID;
    this.sockets();
  }
  init() {
    let object = {
      roomID: this.roomID,
      user: {
        username: this.g.user.username,
        avatar: this.g.user.avatar,
        id: this.g.user.id
      }
    };
    let device = new mediasoup.Device();
    this.g.$socket.emit("viewer private donator join", object, async data => {
      if (
        data.response == "room full" ||
        data.response == "not friends" ||
        data.response == "not found" ||
        data.response == "banned" ||
        data.response == "already in"
      ) {
        this.g.roomOwner = this.g.user;
        this.g.sockets.unsubscribe("donator private closed");
        this.g.sockets.unsubscribe("update users");
        this.g.sockets.unsubscribe("reconnect");
        if (data.response == "room full")
          this.g.$root.$alert("Error", "That room is full.", { color: "red" });
        if (data.response == "not friends")
          this.g.$root.$alert(
            "Error",
            "That person is not friends with you and they are hosting a private room.",
            { color: "red" }
          );
        if (data.response == "not found")
          this.g.$root.$alert(
            "Error",
            "That room doesn't exist or isn't open.",
            { color: "red" }
          );
        if (data.response == "banned")
          this.g.$root.$alert("Error", "You are banned from that room.", {
            color: "red"
          });
        if (data.response == "already in")
          this.g.$root.$alert("Error", "You are already in that room.", {
            color: "red"
          });
        this.g.closeViewer();
        return;
      }
      this.g.roomName = data.roomName;
      this.g.roomDescription = data.roomDescription;
      this.g.roomOwner = data.roomOwner;
      this.g.users = data.users;
      this.g.emoticons = data.emoticons;

      await device.load({
        routerRtpCapabilities: data.rtpCapabilities
      });

      const transport = device.createRecvTransport(data.params);

      transport.on("connect", async ({ dtlsParameters }, callback) => {
        this.g.$socket.emit(
          "connect consumer transport",
          {
            roomID: this.roomID,
            user: object.user,
            dtlsParameters: dtlsParameters
          },
          function() {
            callback();
          }
        );
      });

      this.g.$socket.emit(
        "private create consumer",
        {
          user: object.user,
          roomID: object.roomID,
          rtpCapabilities: device.rtpCapabilities
        },
        async data => {
          const stream = new MediaStream();

          const videoConsumer = await transport.consume({
            id: data.video.id,
            producerId: data.video.producerId,
            kind: data.video.kind,
            rtpParameters: data.video.rtpParameters,
            codecOptions: {}
          });

          if (data.audio !== null) {
            const audioConsumer = await transport.consume({
              id: data.audio.id,
              producerId: data.audio.producerId,
              kind: data.audio.kind,
              rtpParameters: data.audio.rtpParameters,
              codecOptions: {}
            });
            stream.addTrack(audioConsumer.track);
          }

          stream.addTrack(videoConsumer.track);

          this.g.$socket.emit("resume", {
            user: object.user,
            roomID: this.roomID
          });

          this.g.setStream(stream);
          this.g.privateRoom = false;
        }
      );
    });
  }
  sockets() {
    this.g.sockets.subscribe("donator private closed", () => {
      this.g.roomOwner = this.g.user;
      this.g.sockets.unsubscribe("donator private closed");
      this.g.sockets.unsubscribe("update users");
      this.g.sockets.unsubscribe("update emoticons");
      this.g.sockets.unsubscribe("leave room");
      this.g.$root.$alert("Notice", "The room you were in has closed.");
      this.g.closeViewer();
    });

    this.g.sockets.subscribe("leave room", banned => {
      this.g.roomOwner = this.g.user;
      this.g.sockets.unsubscribe("donator private closed");
      this.g.sockets.unsubscribe("update users");
      this.g.sockets.unsubscribe("update emoticons");
      this.g.sockets.unsubscribe("leave room");
      if (banned) {
        this.g.$root.$alert("Notice", "You have been banned.");
      } else {
        this.g.$root.$alert("Notice", "You have been kicked.");
      }
      this.g.closeViewer();
    });

    this.g.sockets.subscribe("update users", users => {
      this.g.users = users;
    });

    this.g.sockets.subscribe("update emoticons", emoticons => {
      this.g.emoticons = emoticons;
    });

    this.g.sockets.subscribe("reconnect", () => {
      if (this.g.streaming)
        this.g.$socket.emit("reconnection", {
          user: this.g.user,
          roomID: this.roomID
        });
    });
  }

  close(callback) {
    this.g.roomOwner = this.g.user;
    this.g.sockets.unsubscribe("donator private closed");
    this.g.sockets.unsubscribe("update users");
    this.g.sockets.unsubscribe("update emoticons");
    this.g.sockets.unsubscribe("leave room");
    this.g.closeViewer(true);
    callback();
  }
}
